export default __webpack_public_path__ + "assets/WSJ.53743871.png";